import React from "react";
import { FaEdit, FaTrash } from "react-icons/fa";

function LanguageTable({ languages, onEdit, onDelete }) {
    return (
        <table className="app-table">
            <thead>
            <tr>
                <th>Id</th>
                <th>Language Code</th>
                <th>Language Name</th>
                <th>Edit</th>
                <th>Delete</th>
            </tr>
            </thead>
            <tbody>
            {languages.map(language => (
                <LanguageRow language={language} key={language.id} onEdit={onEdit} onDelete={onDelete} />
            ))}
            </tbody>
        </table>
    );
}

function LanguageRow({ language, onEdit, onDelete }) {
    return (
        <tr>
            <td>{language.id}</td>
            <td>{language.code}</td>
            <td>{language.name}</td>
            <td>
                <FaEdit className="edit-icon" onClick={() => onEdit(language)} />
            </td>
            <td>
                <FaTrash className="delete-icon" onClick={() => onDelete(language.id)} />
            </td>
        </tr>
    );
}

export default LanguageTable;
